import {
    CancellationChargesV2Response,
    SpecificFeeTypes,
    AncillaryFee
} from '@services/subscription/SubscriptionService';

export type CancellationChargesState = {
    // Raw API payload
    calculated_charges: SpecificFeeTypes[];
    ancillary_charges: AncillaryFee[];
};

export type CancellationChargesAction =
    | { type: "SET_API_CHARGES"; payload: CancellationChargesV2Response }
    | { type: "SET_ANCILLARY_CHARGES"; payload: AncillaryFee[] }

export const cancellationChargesInitialState: CancellationChargesState = {
    calculated_charges: [],
    ancillary_charges: [],
};

export function cancellationChargesReducer(state: CancellationChargesState, action: CancellationChargesAction): CancellationChargesState {
    switch (action.type) {
        case "SET_API_CHARGES": {
            const payload = action.payload || {charges: [], warnings: []} as CancellationChargesV2Response;
            const charges = Array.isArray(payload.charges) ? payload.charges : [];

            return {
                ...state,
                calculated_charges: charges,
            };
        }
        case "SET_ANCILLARY_CHARGES": {
            return {
                ...state,
                ancillary_charges: action.payload || []
            };
        }
        default:
            // Unknown action - return current state
            console.error("Unknown action type in cancellationChargesReducer:", action);
            return state;
    }
}